export default function Progress() {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: 'hidden',
        },
        bar: {
          borderRadius: 4,
        },
        colorPrimary: {},
        buffer: {
          backgroundColor: 'transparent',
        },
      },
    },
  };
}
